import { render, staticRenderFns } from "./signupPage.vue?vue&type=template&id=5e2125f0&scoped=true&"
import script from "./signupPage.vue?vue&type=script&lang=js&"
export * from "./signupPage.vue?vue&type=script&lang=js&"
import style0 from "./signupPage.vue?vue&type=style&index=0&id=5e2125f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2125f0",
  null
  
)

export default component.exports